import React, { Component } from 'react';
import { Link } from 'react-router';
import Nav from './Nav';
import { getProfile } from '../utils/AuthService';
import settings from '../../settings';
import Mailto from 'react-mailto';
import ActivityIndicator from 'react-activity-indicator';
import {  getClientsCreatedByLoggedInUser, deleteClient } from '../utils/developercentre-api';
import '../App.css';

class Clients extends Component {

  constructor() {
    super()
    this.state = { clients: [], loading: true, deleted: true, showLoader: false, loaded: false };
  }

  getClientsBelongingToUser() {
    var userId = getProfile().sub;
    getClientsCreatedByLoggedInUser(userId).then( clients => {
      if (clients.data.length == 0) {
        this.setState({ clients: null });
        this.setState({ loaded: true });
      } else {
        this.setState({ clients: clients.data });
        this.setState({ loaded: true });
      }
    });
  }

  componentDidMount() {
    this.getClientsBelongingToUser();
    this.setState({ loading: false });
  
  }

  viewDocumentation(clientID) {

  }

  handleApplicationDeletion(clientID) {

    this.setState({ showLoader: true });
    var userId = getProfile().sub;
    var _this = this;
    deleteClient(clientID,userId).then(response => {
      if( response.status === 200) {
        _this.setState({ deleted: false });
        window.location.reload();
      }
      _this.setState({ showLoader: false });
    });
  }

  deleteApplication = (clientID) => {
    var decision = confirm("Are you sure you want to delete this client?");
    if (decision) {
      this.handleApplicationDeletion(clientID);
      return;
    }
  }

  render() {

    const { clients, loading, deleted, showLoader, loaded }  = this.state;    
    var userID = getProfile().sub

    return (
        <div>
          <Nav />
          <h3 className="text-center">Developer Applications</h3>
          <Link className="btn btn-lg btn-success" to='/register'>Register a New Application</Link> &nbsp;
          <hr/>

          <div className="doc-link">
            <span className="badge alert-info"><a href={settings.apiDocLink} target="_blank">Check this link for documentation on how to consume our API </a></span> 
          </div>

          <div className="col-sm-12">
            { showLoader ? <div className="alert alert-default"><ActivityIndicator number={5} duration={200} activeColor="#d9534f" borderWidth={2} borderRadius="50%" diameter={25} /></div> : '' }
            { deleted ? '' : <div className="alert alert-success"> The Client has been deleted successfully. View registered applications. </div> }
            { !loaded ? <div className="alert alert-default"><ActivityIndicator number={5} duration={200} activeColor="#0070bf" borderWidth={2} borderRadius="50%" diameter={25} /></div> : '' }
          </div>

          { 
            (clients !== null) ?  
            clients.map((client, index) => (
              <div className="col-sm-12" key={index}>
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h3 className="panel-title"> Client Application Name: <span className="btn">{ client.client_name }</span></h3>
                  </div>
                  <div className="panel-body">
                    <p><span className="badge alert-info"> Client ID: </span><strong> { client.client_id } </strong></p>
                    <p><span className="badge alert-danger"> Client Secret: </span><strong> { client.client_secret } </strong></p>
                    <p><span className="badge alert-success"> Redirect URIs: </span><strong> { client.redirect_uris.join(',') } </strong></p>
                    <button onClick={() => this.deleteApplication(client.client_id,)} className="btn btn-danger"> Delete Client </button>&nbsp;
                    <Link to={`/regular-doc/${client.client_id}`} className="btn btn-default"> View Documentation </Link>
                  </div>
                </div>
              </div>
            )) : <div className="alert alert-danger" role="alert"><strong>Oh snap!</strong> No Clients Available </div>
          }

        </div>
    );
  }
}

export default Clients;



// WEBPACK FOOTER //
// ./src/components/Clients.js